export enum DepartmentTypeEnum {
  Custom = 'custom',
  Group = 'group',
}
